import { Grid, TextField, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { convertirVEF } from '../../../../helpers/ConversionesHelper';
import { useNotification } from '../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import {
  saveConceptosAction,
  setActivoConceptosAction,
} from '../ConceptosAction';

const FormConceptos = ({ isDelete = false }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const conceptosStore = Redux.useSelector((state) => state.conceptos);
  const entMonedasStore = Redux.useSelector((state) => state.entMonedas);

  const activo = isDelete ? null : conceptosStore.activo;

  const initData = {
    nombre: '',
    codigo: '',
    costo: '',
    desc: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    codigo: false,
    costo: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [cambio, setCambio] = React.useState([]);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idEstatus: activo.estatus?.id ?? 1,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!entidadesStore.activo) {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveConceptosAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idEntidad: entidadesStore.activo.id,
        },
        conceptosStore.params,
      );
      if (res) clearData();
      setLoadingSave(false);
    }
  };

  function clearData() {
    setActivoConceptosAction(dispatch, null);
    setData(initData);
  }

  React.useEffect(() => {
    if (data.costo) {
      entMonedasStore.all.forEach((moneda) => {
        if (moneda.cambio) {
          let total = 0.0;
          if (moneda.cambio.abrev === 'VEF') {
            total = convertirVEF(moneda.tasa, data.costo);
          }
          setCambio({
            moneda,
            total,
          });
        }
      });
    } else {
      setCambio({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.costo]);

  return (
    <Box component="form" sx={{ m: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          <Typography variant="h6">
            {activo ? 'Editar asunto' : 'Crear'}
          </Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.codigo.name}
            required
            label={CONST.codigo.label}
            value={data.codigo}
            onChange={(e) =>
              _handleSetDataField(CONST.codigo.name, e.target.value)
            }
            helperText={dataError.codigo ? validMessage.required : null}
            error={dataError.codigo}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nombre.name}
            required
            label={CONST.nombre.label}
            value={data.nombre}
            onChange={(e) =>
              _handleSetDataField(
                CONST.nombre.name,
                e.target.value.toUpperCase(),
              )
            }
            helperText={dataError.nombre ? validMessage.required : null}
            error={dataError.nombre}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.costo.name}
            required
            label="Costo en $ (USD)"
            value={data.costo}
            onChange={(e) => {
              if (!/^([0-9.])*$/.test(e.target.value)) return;
              _handleSetDataField(CONST.costo.name, e.target.value);
            }}
            helperText={dataError.costo ? validMessage.required : null}
            error={dataError.costo}
          />
          <Typography variant="body1" color="initial" align="end">
            <strong>{cambio.moneda?.cambio.simbolo}</strong> {cambio.total}{' '}
            <strong>{cambio.moneda?.cambio.abrev}</strong>
          </Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={4}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
            required
            error={dataError.estatus}
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            mr={2}
            saveIcon
          />
          {activo && (
            <BotonComponent
              click={clearData}
              text="CANCELAR"
              disabled={loadingSave}
              black
              closeIcon
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormConceptos;
